export default __webpack_public_path__ + "static/media/match.d7b8f3ac.svg";